<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p36"><span><a id="page_28"></a><a href="#/Contents#rp36">HERBED BROCCOLI-CAULIFLOWER BISQUE</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>This healthful soup is so delicious, you’ll want to make enough for the freezer!</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>2 medium stalks broccoli</span></p>
<p class="hang"><span>½ small head cauliflower</span></p>
<p class="hang"><span>1 cup thinly sliced green onions</span></p>
<p class="hang"><span>2 teaspoons margarine or butter</span></p>
<p class="hang"><span>1 tablespoon flour</span></p>
<p class="hang"><span>3 cups Chicken Stock (see <a href="#/Chapter012#p2">p. 2</a>)</span></p>
<p class="hang"><span>1½ cups coarsely chopped peeled potatoes</span></p>
<p class="hang"><span>1 tablespoon dried basil leaves</span></p>
<p class="hang"><span>1½ cups 2% reduced-fat milk</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Cut enough broccoli and cauliflower into florets to make ¾ cup each; reserve. Coarsely chop remaining broccoli and cauliflower. Sauté green onions in margarine in large saucepan until tender, about 4 minutes. Stir in flour; cook 1 minute. Stir in stock, chopped vegetables, and basil; heat to boiling. Reduce heat and simmer, uncovered, until vegetables are tender, about 10 minutes. Process soup in food processor or blender until smooth; return to saucepan. Add milk and reserved vegetable florets. Heat to boiling; reduce heat and simmer until florets are crisp-tender, about 5 minutes. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 121</span></p>
<p class="per1"><span>% calories from fat: 19</span></p>
<p class="per1"><span>Protein (g): 7</span></p>
<p class="per1"><span>Carbohydrate (g): 18.6</span></p>
<p class="per1"><span>Fat (g): 2.7</span></p>
<p class="per1"><span>Saturated fat (g): 1</span></p>
<p class="per1"><span>Cholesterol (mg): 4.5</span></p>
<p class="per1"><span>Sodium (mg): 230</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0218.vue?a29f6210